import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { SpecialAgreementsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.SpecialAgreement };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
  uploadStatus: { type: number; loaded: number; total?: number };
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    SpecialAgreementsActions.CreateSpecialAgreement,
    SpecialAgreementsActions.ReadSpecialAgreement,
    SpecialAgreementsActions.ReadSpecialAgreements,
    SpecialAgreementsActions.UpdateSpecialAgreement,
    SpecialAgreementsActions.DeleteSpecialAgreement,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    SpecialAgreementsActions.ReadSpecialAgreementSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    SpecialAgreementsActions.ReadSpecialAgreementsSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.SpecialAgreement },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),

  on(
    SpecialAgreementsActions.CreateSpecialAgreementSuccess,
    SpecialAgreementsActions.UpdateSpecialAgreementSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    SpecialAgreementsActions.DeleteSpecialAgreementSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    SpecialAgreementsActions.CreateSpecialAgreementFail,
    SpecialAgreementsActions.ReadSpecialAgreementFail,
    SpecialAgreementsActions.ReadSpecialAgreementsFail,
    SpecialAgreementsActions.UpdateSpecialAgreementFail,
    SpecialAgreementsActions.DeleteSpecialAgreementFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
